import PropTypes from 'prop-types';

import { getLabelMessage } from '@gef-ui/localization/messages';

import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { joinString } from 'utils/string';

export const Toolbar = ({ campaignDetail }) => {
	const subheaderTitle = useRenderSubheaderTitle({
		pageTitle: joinString(' ', [getLabelMessage('campaignSubsellerNomination:title'), campaignDetail?.fullName]),
		backButton: true,
	});

	return <ToolbarTemplate leftSide={<Subheader title={subheaderTitle} />} />;
};

Toolbar.propTypes = {
	campaignDetail: PropTypes.object,
};

export default Toolbar;
